import { useQuery } from 'react-query';
import { orderMicroService } from '../services';
import { bugSnagNotifyAPIError } from 'src/helper/bugSnagHelper';
import { ORDER_MICRO_SERIVCE } from 'src/constants';
import axiosNoInterceptor from 'src/services/axiosNoInterceptor';

const requestPaymentLink = async (id: string) => {
  const response = await await axiosNoInterceptor.get(`${ORDER_MICRO_SERIVCE}/request-payment/${id}?is_catering=1`, {
    headers: {
      'Authorization': "token",
      'token': "token"
    }
  })
  return response.data.data;
};

export default function useRequestPaymentLink(id: string) {
  return useQuery(id, () => requestPaymentLink(id), {
    // retry: false,
    cacheTime: 0,
    staleTime: 0,
    enabled: Boolean(id),
    onError: (error: any) => {
      bugSnagNotifyAPIError("/request-payment", { ...error?.response }, error?.response?.data?.message)
    }
  });
}
